import React from 'react'
import PropTypes from 'prop-types'
import { Image } from '@chakra-ui/react'
import { breakpoints } from '../../lib/constants'

const CustomImage = ({ obj, borderRadius, fit }) => {
    const imageUrl = giveMeTheImage(obj)
    const sourceArr = giveMeTheSourceArray(obj)

    return (
        <picture>
            {sourceArr.map((arr) => (
                <source
                    key={arr.point}
                    media={`(max-width: ${arr.point}px)`}
                    data-srcset={arr.srcSet}
                    srcSet={arr.srcSet}
                    type={giveMeTheImageType(obj)}
                />
            ))}
            <Image
                objectFit={fit}
                w={'100%'}
                h={'100%'}
                borderRadius={borderRadius}
                src={imageUrl}
                srcSet={giveMeTheSrcSet(obj)}
                sizes={giveMeTheSizes(obj)}
                alt={giveMeTheAlt(obj)}
                fallbackSrc={giveMeTheFallback(obj)}
            />
        </picture>
    )
}

CustomImage.propTypes = {
    obj: PropTypes.object,
    borderRadius: PropTypes.number,
    fit: PropTypes.string,
}

CustomImage.defaultProps = {
    fit: 'contain',
    borderRadius: 0,
}

const giveMeTheSourceArray = (obj) => {
    const srcSet = giveMeTheSrcSet(obj)
    const srcSetArray = String(srcSet).trim().split(',')

    let res = []

    srcSetArray.forEach((value, index) => {
        const firstPartOfValue = value.split(' ')[0]

        const objNew = {
            point: breakpoints[index],
            srcSet: firstPartOfValue,
        }
        res.push(objNew)
    })

    return res
}

const giveMeTheImage = (obj) => {
    return obj?.url
}

const giveMeTheSrcSet = (obj) => {
    return obj?.gatsbyImageData.images.sources[0].srcSet
}

const giveMeTheSizes = (obj) => {
    return obj?.gatsbyImageData?.images?.sources[0]?.sizes
}

const giveMeTheAlt = (obj) => {
    return obj?.description || obj?.title
}

const giveMeTheFallback = (obj) => {
    return obj?.gatsbyImageData?.placeholder?.fallback
}

const giveMeTheImageType = (obj) => {
    return obj?.gatsbyImageData?.images?.sources[0]?.type
}

export default CustomImage
